import "./bootstrap";
import "@theme-style";
import Es6Promise from "es6-promise";
import "unfetch/polyfill";

import "babel-polyfill";
import { createApp, configureCompat } from "vue";
import VueFeather from "vue-feather";
import store from "./store/store";
//config
import Package from "../../package.json";

// Route
import Routes from "./routes";

// App
import App from "./App.vue";

import { polyfill as MobileDragAndDropPolyfill } from "mobile-drag-drop";
import { scrollBehaviourDragImageTranslateOverride } from "mobile-drag-drop/scroll-behaviour";

const ua = window.navigator.userAgent.toLowerCase();
const isiPad = ua.indexOf("ipad") > -1 || (ua.indexOf("macintosh") > -1 && "ontouchend" in document);

const usePolyfill = MobileDragAndDropPolyfill({
    holdToDrag: 80,
    forceApply: isiPad, // force apply for ipad
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride || isiPad,
});

if (usePolyfill) {
    document.addEventListener("dragenter", (event) => event.preventDefault());
    window.addEventListener("touchmove", () => {}, { passive: false });
}

// Layout
import AuthLayout from "./layouts/Auth/Default.vue";
import RegistrationLayout from "./layouts/Auth/Registration.vue";
import DefaultLayout from "./layouts/Default/Default.vue";
import PasswordresetLayout from "./layouts/Auth/Passwordreset.vue";

import BookingLayout from "./layouts/Booking/Default.vue";
import BookingWidget from "./layouts/Booking/Public/Widget/Widget.vue";
import BookingWidgetPage from "./layouts/Booking/Public/Widget/Widgetpage.vue";

import ClickAndCollectLayout from "./layouts/ClickAndCollect/Default.vue";
import OrderingTableLayout from "./layouts/OrderingTable/Default.vue";

import GiftVouchersLayout from "./layouts/GiftVouchers/Default.vue";

import WebsiteLayout from "./layouts/Website/Default.vue";

import CampaignsLayout from "./layouts/Campaigns/Default.vue";

import ErrorsLayout from "./layouts/Errors/Default.vue";

// plugin
import VueTelInput from "./components/forms/VueTelInputCompat.vue";
import i18n from "./plugins/i18n";
import lodash from "./plugins/lodashAsAPlugin";
import TooltipPlugin from "./plugins/tooltip";

// Global Enums
import LangsEnum from "./mixins/enums/LangsEnum.js";

// Global Mixins
import UtilsHelper from "./mixins/helpers/Utils.js";
import DateUtilsHelper from "./mixins/helpers/DateUtils.js";
import EnvUtils from "./mixins/helpers/EnvUtils.js";

// Theme
import theme from "./themes/loader.js";

//Modals
import Modal from "./components/Modals/base/Modal.vue";
import ModalNoMarginNoPadding from "./components/Modals/base/ModalNoMarginNoPadding.vue";
import ErrorsInterceptor from "./axios/Interceptors/ErrorsInterceptor";
import Notifications from "vue-notification";

import Konva from "konva";

import countries from "i18n-iso-countries";
import { DEVELOPMENT, PRODUCTION } from "./utils/envs";
import { initSentry } from "./plugins/sentry.js";
import { installTranslationHelpers } from "./plugins/i18n";

Es6Promise.polyfill();

configureCompat({
    MODE: 2,
});

// Register languages for i18n-iso-countries
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

ErrorsInterceptor();

const app = createApp(App);

app.config.globalProperties.$__BUILD_ID__ = BUILD_ID;
app.prototype = app.config.globalProperties;

app.use(store);
app.use(Routes);
app.use(i18n);
app.use(lodash);
app.use(TooltipPlugin);
app.component("vue-tel-input", VueTelInput);
app.use(theme);
app.use(Notifications);

installTranslationHelpers(app);

app.component("feather", VueFeather);

app.component("auth-layout", AuthLayout);
app.component("registration-layout", RegistrationLayout);
app.component("booking-layout", BookingLayout);
app.component("booking-widget-layout", BookingWidget);
app.component("booking-widget-page-layout", BookingWidgetPage);
app.component("click-and-collect-layout", ClickAndCollectLayout);
app.component("ordering-table-layout", OrderingTableLayout);
app.component("gift-vouchers-layout", GiftVouchersLayout);
app.component("website-layout", WebsiteLayout);
app.component("campaigns-layout", CampaignsLayout);
app.component("default-layout", DefaultLayout);
app.component("passwordreset-layout", PasswordresetLayout);
app.component("errors-layout", ErrorsLayout);
app.component("modal", Modal);
app.component("modal-m0-p0", ModalNoMarginNoPadding);

app.mixin(LangsEnum);
app.mixin(UtilsHelper);
app.mixin(DateUtilsHelper);
app.mixin(EnvUtils);

app.directive("visible", (el, bind) => {
    el.style.visibility = bind.value ? "visible" : "hidden";
});

if (ENABLE_SENTRY) {
    initSentry(app, Routes);
}

Routes.isReady().then(() => {
    app.mount("#app");
});
